// src/store/projectlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import secureLocalStorage from 'react-secure-storage';
import { getBooleanValue, getStoredData } from '@/utils/store';
import { Project } from '@/types/project';

interface ProjectsState {
  projects: Project[] | []
  projectsFetched: boolean
  currentProject: Project | null
}

const initialState: ProjectsState = {
    projects: getStoredData<Project[]>('projects', []),
    projectsFetched: getBooleanValue('projectsFetched'),
    currentProject: null
};

const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setProjects: (state, action: PayloadAction<Project[]>) => {
      state.projects = action.payload;
      state.projectsFetched = true;

      secureLocalStorage.setItem('projects', JSON.stringify(action.payload) || '');
      secureLocalStorage.setItem('projectsFetched', JSON.stringify(true) || '');
    },
    setCurrentProject: (state, action: PayloadAction<Project>) => {
      state.currentProject = action.payload;
    },
    clearProjects: (state) => {
      state.projects = [];
      state.projectsFetched = false;
      state.currentProject = null;

      secureLocalStorage.removeItem('projects');
      secureLocalStorage.removeItem('projectsFetched');
      secureLocalStorage.removeItem('currentProject');
    },
  },
});

export const { setProjects, clearProjects, setCurrentProject } = projectsSlice.actions;
export default projectsSlice.reducer;
